module.exports = __webpack_public_path__ + "img/calix.jpg";